var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.visibleBreaks),function(interval,index){return _c('timeline-break',{key:index,attrs:{"start":interval.start,"end":interval.end,"border-width":_vm.breakBorderWidth}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }